import * as React from "react";
import type { TooltipRenderProps } from "react-joyride";
import { useTranslation } from "react-i18next";
import type { EwTourStepData, TourMedia } from "./types";

function TourMediaPanel({ media }: { media?: TourMedia }) {
  if (!media?.src) return null;
  return (
    <div className="ew-product-tour__media">
      <img
        src={media.src}
        alt=""
        className="ew-product-tour__media-img"
        data-media-type={media.type}
      />
    </div>
  );
}

export default function ProductTourTooltip(props: TooltipRenderProps) {
  const { t } = useTranslation("productTour");
  const {
    continuous,
    index,
    size,
    step,
    primaryProps,
    skipProps,
    tooltipProps,
    isLastStep,
  } = props;

  const data = (step as { data?: EwTourStepData }).data;
  const eyebrow = data?.eyebrowKey ? t(data.eyebrowKey) : null;
  const title = data?.titleKey ? t(data.titleKey) : step.title;
  const body = data?.bodyKey ? t(data.bodyKey) : step.content;
  const cta = data?.ctaKey
    ? t(data.ctaKey)
    : isLastStep
      ? t("common.gotIt")
      : t("common.continue");
  const progressTotal = data?.progressTotal ?? size;
  const progressIndex = data?.progressIndex ?? index;

  return (
    <div className="ew-product-tour__tooltip" {...tooltipProps}>
      {eyebrow ? (
        <p className="ew-product-tour__eyebrow">{eyebrow}</p>
      ) : null}
      {title ? <h3 className="ew-product-tour__title">{title}</h3> : null}
      <div className="ew-product-tour__body">{body}</div>
      <TourMediaPanel media={data?.media} />
      <div className="ew-product-tour__footer">
        <div className="ew-product-tour__dots" aria-hidden>
          {Array.from({ length: progressTotal }).map((_, i) => (
            <span
              key={i}
              className={
                i === progressIndex
                  ? "ew-product-tour__dot ew-product-tour__dot--active"
                  : "ew-product-tour__dot"
              }
            />
          ))}
        </div>
        <div className="ew-product-tour__actions">
          {!isLastStep ? (
            <button
              type="button"
              className="ew-product-tour__skip"
              {...skipProps}
            >
              {t("common.skip")}
            </button>
          ) : null}
          {continuous ? (
            <button
              type="button"
              className="ew-product-tour__cta"
              {...primaryProps}
            >
              {cta}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
